/**
 * 活动主视图渲染逻辑
 */
import { memoryCache } from 'mihoyo-store';
import ClipboardJS from 'clipboard';
import { CACHE_INSTANCE_ID, CACHE_USER_LIST } from '@configPath/cacheConfigs/memoryCache.config';
import customEvent from 'mihoyo-custom-event';
import { START_LIST_RENDER, TO_TARGET } from '@configPath/eventConfigs/customEvent.config';
import model from '../models/default';
import page1 from '../views/page1/page1';
import page2 from '../views/page2/page2';
import page3 from '../views/page3/page3';
import page4 from '../views/page4/page4';
import page5 from '../views/page5/page5';
import modal from './modal';

// memoryCache的存在仅仅是为了演示多个模块之间共享数据的方法，可删除相关代码
// const memoryCache = Store.getInstance();

export default {
  /**
   * 统一的渲染入口，方法名固定，不要更改
   */
  render() {
    page1.render();
    page2.render();
    page3.render();
    page4.render();
    page5.render();
    this.initial();
    this.events();
  },

  /**
   * 视图事件集中绑定
   */
  events() {
    $('.navbar').on('click', (e) => {
      const classArray = e.target.classList[1].split('-');
      const pageNum = classArray[classArray.length - 1];
      if (pageNum === '2') {
        customEvent.emit(START_LIST_RENDER, {});
      }
      this.jump('.page', `.page-${pageNum}`);
    });
    $('.fullscreen').on('click', (e) => {
      $('.fullscreen').css('display', 'none');
    });
  },

  fs(e) {
    const src = $(e.target).find('img').context.src;
    $('.fullscreen').html(this.imgHandler(src));
    $('.fullscreen').css('display', 'flex');
  },
  changeNavbar(to) {
    const pageNum = to.split('-')[1];
    $('.navbar-page-1').removeClass('navbar-page-1-active');
    $('.navbar-page-2').removeClass('navbar-page-2-active');
    $('.navbar-page-3').removeClass('navbar-page-3-active');
    $(`.navbar-page-${pageNum}`).addClass(`navbar-page-${pageNum}-active`);
  },

  jump(from,to) {
    if(typeof(from) === 'string'){
      from = $(from);
    }
    if(typeof(to) === 'string'){
      to = $(to);
    }
    if(from instanceof window.jQuery && to instanceof window.jQuery){
      from.css('display','none');
      to.css('display','block');
      this.changeNavbar(to[0].className);
    }else{
      console.log('params error, params should be string or jquery object');
    }
  },

  handleFail({message, retcode}) {
    if (retcode === -100) {
      // window.location.href="https://webstatic-test.mihoyo.com/mihoyo/common/accountSystemFE/index.html#/login/captcha?cb_url="+window.location.href; 
      window.location.href="https://user.mihoyo.com/#/login/captcha?cb_url="+window.location.href;
    } else {
      modal('.cancel-modal', message);
    }
  },

  imgSumHandler(selector) {
    $(selector).each(function(){
      const className = (img) => img.width + $(this.parentNode).height() < img.height + $(this.parentNode).width() ? 'widthflex' : 'heightflex';
      if (this.complete) {
        $(this).addClass(className(this));
      } else {
        $(this).one('load', function(){
          $(this).addClass(className(this));
        });
      }
    });
  },

  imgHandler(src, full) {
    const img = new Image();
    img.src = src;
    const className = () => img.width >= img.height ? 'widthflex' : 'heightflex';
    if (full) {
      img.className = 'fullimg';
    } else if (img.complete) {
      img.className = className();
    } else {
      img.onload = function (e) {
        $(e.target).addClass(className());
        img.onload = null;
      }
    }
    return img;
  },

  initClip(id) { 
    new ClipboardJS('.share',{
      text: function() {
        return `${window.location.href.split('?')[0]}?id=${id}`;
      }
    });
  },

  initial() {
    const targetId = window.location.href.split('?id=')[1];
    if (window.location.href.indexOf('login_ticket') !== -1){
      model.getCookieToken();
    }
    if (targetId) {
      customEvent.emit(TO_TARGET, {id:targetId});
    }
    model.initial().then(({can_post, is_login, is_post}) => {
      if (is_post) {
        $('.page-1-myporn').css('display', 'block');
      }
    }).fail(this.handleFail);
  }
}


